function initMobileMenu() {
    // Toggle mobile icon
    const mobileNavTrigger = document.querySelector(".header-shop #hamburger");

    if (mobileNavTrigger) {
        mobileNavTrigger.addEventListener("click", () => {
            document.body.classList.toggle("mobile-nav-open");
        });
    }

    // Toggle mobile category toggles
    const listTriggers = [...document.querySelectorAll(".nav-mobile-toggler")];

    listTriggers.forEach(trigger => {
        trigger.addEventListener("click", function(e) {
            this.closest("li").classList.toggle("active");

            e.preventDefault();
        });
    });
}

export default function() {
    initMobileMenu();
}
